// extracted by mini-css-extract-plugin
module.exports = {"text-block":"_3ce9c","textBlock":"_3ce9c","wrapper":"_55d47","image-block":"bd89f","imageBlock":"bd89f","buttons":"_1439d","button":"b361a","image":"_59f68"};